import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import SolicitacaoAdminService from "../../services/resource/solicitacaoAdminService";

const service = new SolicitacaoAdminService();

// Listagem "Gerenciar Solicitações" (admin) — mesmo shape de useSolicitacoes.js, mas via o
// endpoint /admin (sem restrição de visibilidade, inclui ELIMINADA quando o filtro pedir).
export function useGerenciarSolicitacoes(tipoProcesso, status, dataInicial, dataFinal) {
    const [solicitacoes, setSolicitacoes] = useState([]);
    const [loading, setLoading] = useState(true);

    const carregar = useCallback(() => {
        if (!dataInicial || !dataFinal) {
            setSolicitacoes([]);
            return;
        }
        setLoading(true);
        service.listar(tipoProcesso || undefined, status || undefined, dataInicial, dataFinal)
            .then(res => setSolicitacoes(res.data))
            .catch(error => {
                console.error("Erro ao listar solicitações (admin)", error);
            })
            .finally(() => setLoading(false));
    }, [tipoProcesso, status, dataInicial, dataFinal]);

    useEffect(() => {
        carregar();
    }, [carregar]);

    return { solicitacoes, loading, recarregar: carregar };
}
